/// <amd-module name="VSS/Features/SignalR/HubProxies" />
import { Connection } from "signalR";
import { jqueryShimmed } from "VSS/Features/SignalR/3rdParty/jquery.shimmed";
import { ISignalRHubProxy } from "VSS/Features/SignalR/HubProxies.types";


let allProxies: { [key: string]: any } = {};
let subscribedProxies: { [key: string]: boolean } = {};
let unsubscribedProxies: { [key: string]: boolean } = {};

const $ = jqueryShimmed;

export function getBaseProxyObject<C, S>(connection: Connection, name: string): ISignalRHubProxy<C, S> {
    if (!connection || typeof (connection as any).createHubProxy !== "function") {
        throw new Error("SignalR: Connection is not initialized yet, create hubconnection first.");
    }

    let proxy = (connection as any).createHubProxy(name);
    if (!proxy.client) {
        proxy.client = {} as C;
    }

    return proxy;
}

export function registerProxy<C, S>(connection: Connection, name: string, proxy: ISignalRHubProxy<C, S>) {
    if (!proxy.client) {
        // Ensure client exists, if they are registering the client later
        proxy.client = {} as C;
    }

    const signalR = $.signalR;
    signalR[name] = proxy;
    allProxies[name] = proxy;

    // Register only current proxy
    let currentProxies: any = {};
    currentProxies[name] = proxy;
    registerProxiesToConnection(connection, currentProxies);
}

export function getHubProxies() {
    return allProxies;
}

export function disposeProxies() {
    allProxies = {};
    subscribedProxies = {};
    unsubscribedProxies = {};
}

function registerProxiesToConnection(connection: Connection, proxies: { [key: string]: ISignalRHubProxy<any, any> }) {
    connection
        .starting(function() {
            // Register the hub proxies as subscribed
            // (instance, shouldSubscribe)
            registerHubProxies(proxies, true);

            (connection as any)._registerSubscribedHubs();
        })
        .disconnected(function() {
            // Unsubscribe all hub proxies when we "disconnect".  This is to ensure that we do not re-add functional call backs.
            // (instance, shouldSubscribe)
            registerHubProxies(proxies, false);
        });
}

function registerHubProxies(proxies: { [key: string]: ISignalRHubProxy<any, any> }, shouldSubscribe: boolean) {
    for (let key in proxies) {
        if (proxies.hasOwnProperty(key)) {
            let hub = proxies[key];
            let subscriptionMethod;
            if (!(hub as any).hubName) {
                // Not a client hub
                return;
            }

            if (shouldSubscribe && !subscribedProxies[key]) {
                // We want to subscribe to the hub events
                subscriptionMethod = (hub as any).on;
                subscribedProxies[key] = true;
            } else if (!unsubscribedProxies[key]) {
                // We want to unsubscribe from the hub events
                subscriptionMethod = (hub as any).off;
                unsubscribedProxies[key] = true;
            }

            if (subscriptionMethod) {
                // Loop through all members on the hub and find client hub functions to subscribe/unsubscribe
                for (let memberKey in hub.client) {
                    if (hub.client.hasOwnProperty(memberKey)) {
                        let memberValue = hub.client[memberKey];

                        if (typeof memberValue !== "function") {
                            // Not a client hub function
                            continue;
                        }

                        subscriptionMethod.call(hub, memberKey, makeProxyCallback(hub, memberValue));
                    }
                }
            }
        }
    }
}

function makeProxyCallback(hub: any, callback: any) {
    return function() {
        // Call the client hub method
        callback.apply(hub, $.makeArray(arguments));
    };
}
